import { graphql, useFragment } from "react-relay";
import { TodoListItemFooter_todo$key } from "./__generated__/TodoListItemFooter_todo.graphql";
import { TodoListItemFooterDone } from "./TodoListItemFooterDone";
import { TodoListItemFooterPending } from "./TodoListItemFooterPending";

export function TodoListItemFooter(props: {
  todo: TodoListItemFooter_todo$key;
  sizeClass: "compact" | "wide" | "regular";
  currentEmployeeId: string | undefined;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemFooter_todo on Todo {
        ...TodoListItemFooterDone_todo
        ...TodoListItemFooterPending_todo
        status
      }
    `,
    props.todo
  );

  switch (todo.status) {
    case "DONE":
      return <TodoListItemFooterDone todo={todo} />;
    case "PENDING":
      return (
        <TodoListItemFooterPending
          todo={todo}
          sizeClass={props.sizeClass}
          currentEmployeeId={props.currentEmployeeId}
        />
      );
    default:
      return null;
  }
}
